import { createRoot } from '@owlsdepartment/vue-tree-routes';

import base from './base';
import questions from './questions';

export default [...createRoot([base, questions])];
